import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { TEXT_DIRECTION } from 'helpers/isRtlLanguage';

import { Slider } from '@atlas/components';
import { SiteConfigManager, useCasinoNewState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import { GAME_SIZES } from 'components/Pages/Casino/constants';
import GameTile from 'components/Pages/Casino/GameList/GameTile';
import { useIsRtl } from 'hooks/useIsRtl';
const { CASINO } = COMPONENT_TYPES;

const noop = () => {};

const SmarticoRecommendedGames = ({ handleClose, relatedGames, setSwiper }) => {
  const casinoPath = SiteConfigManager.getComponentPath(CASINO, 'casino');
  const isRtl = useIsRtl();
  const dir = useMemo(() => (isRtl ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR), [isRtl]);
  const [gameOverlayId, setGameOverlayId] = useState(null);
  const [isLoadingGame, setIsLoadingGame] = useState(false);

  const { identifyFavoriteGames } = useCasinoNewState();
  useEffect(() => {
    if (!relatedGames.length) return;

    const gameIds = relatedGames.map(({ id }) => id);

    identifyFavoriteGames(gameIds);
  }, [relatedGames, identifyFavoriteGames]);

  const toggleShowOverlay = useCallback(game => {
    const gameIdentifier = game.id;
    setGameOverlayId(prevGameOverlayId =>
      prevGameOverlayId !== gameIdentifier ? gameIdentifier : null,
    );
  }, []);

  return (
    <Slider
      autoplay={false}
      breakpointsBase="container"
      className="casino__slider-games"
      dir={dir}
      loop={false}
      onBeforeInit={setSwiper}
      spaceBetween={8}
    >
      {relatedGames.map((game, index) => {
        const showOverlay = gameOverlayId === game.id;

        return (
          <Slider.Slide key={game.id}>
            <GameTile
              game={game}
              gameBasePathname={casinoPath}
              imageFetchPriority={index < 3 ? 'high' : 'auto'} // set to high for first 3 el-s which are at the first screen (for better LCP)
              imageLoading={index < 3 ? 'eager' : 'lazy'} // set to eager for first 3 el-s which are at the first screen (for better LCP)
              isLoading={isLoadingGame}
              onPlayCallback={handleClose}
              setIsLoading={setIsLoadingGame}
              showOverlay={showOverlay}
              size={GAME_SIZES.SMALL}
              toggleShowOverlay={isLoadingGame ? noop : toggleShowOverlay}
            />
          </Slider.Slide>
        );
      })}
    </Slider>
  );
};

export default SmarticoRecommendedGames;
